module.exports = __webpack_public_path__ + "img/ecologic.a802292d.png";